import { BaseAPI } from './BaseAPI.js'
import { ChannelSession } from '../types/index.js'

export default class ChannelSessionsAPI extends BaseAPI<ChannelSession> {
  override get resource(): string {
    return '/channelSessions'
  }
}
